import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {from, Observable} from 'rxjs';
import {AuthService} from "../auth.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getIsLogin()) {
      return true;
    }
    return this.auth.getIsLoginFromStorage().pipe(map((isLogin): boolean | UrlTree => {
      return isLogin ? true : this.router.parseUrl(appRoutingEnum.MAIN);
    }));
  }

}
